<div class="container-fluid p-0 flex justify-center items-center" style="height: 100vh; overflow: auto; background-color: var(--tis-primary);">
    <div class="bg-white p-8 rounded-lg shadow-xl flex flex-col items-center space-y-6 max-w-sm w-full mx-4">
        <div class="relative">
            <img class="mx-auto h-10 w-auto" src="assets/logo/cantrak-logo.svg" alt="Cantrak">
        </div>
        @if(!tokenVerified) {
            <h1 class="text-2xl font-bold text-gray-800">Verifying Token</h1>
            @if(errorMessage){
                <p class="tis-text-danger text-center">
                    {{errorMessage}}
                </p>
            }
            @else{
                <p class="text-gray-600 text-center">
                    Please wait while we checking ....
                </p>
            }
            <div class="flex items-center space-x-2" *ngIf="loading">
                <div class="w-3 h-3 rounded-full animate-bounce" style="background-color: var(--tis-primary);"></div>
                <div class="w-3 h-3 rounded-full animate-bounce" style="animation-delay: 0.2s; background-color: var(--tis-primary);"></div>
                <div class="w-3 h-3 rounded-full animate-bounce" style="animation-delay: 0.4s; background-color: var(--tis-primary);"></div>
            </div>
        }
        @else {
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                <h4 class="text-gray-800 font-bold">Please enter your new password:</h4>
                <div class="my-2 py-1">
                    <mat-form-field class="tis-mat-form-field" appearance="outline">
                        <mat-label>Password</mat-label>
                        <input type="password" matInput placeholder="Password" formControlName="password" style="width: 100%;">
                        @for (validation of validationMessages.password; track validation.type) {
                            <mat-error *ngIf="forgotPasswordForm.get('password')?.hasError(validation.type) && (forgotPasswordForm.get('password')?.dirty || forgotPasswordForm.get('password')?.touched)">{{validation.message}}</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="tis-mat-form-field" appearance="outline">
                        <mat-label>Confirm Password</mat-label>
                        <input type="password" matInput placeholder="Confrim Password" formControlName="confirmPassword" style="width: 100%;">
                        @for (validation of validationMessages.confirmPassword; track validation.type) {
                            <mat-error *ngIf="forgotPasswordForm.get('confirmPassword')?.hasError(validation.type) && (forgotPasswordForm.get('confirmPassword')?.dirty || forgotPasswordForm.get('confirmPassword')?.touched)">{{validation.message}}</mat-error>
                        }
                    </mat-form-field>
                </div>
    
                <button mat-flat-button class="tis-btn-filled-primary w-full">
                    Submit
                    <i class="fas fa-spinner fa-spin" *ngIf="formLoading"></i>
                </button>
            </form>
        }
    </div>
</div>